import { render, staticRenderFns } from "./ReservationDetailsNew.vue?vue&type=template&id=12702d45&scoped=true&"
import script from "./ReservationDetailsNew.vue?vue&type=script&lang=js&"
export * from "./ReservationDetailsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12702d45",
  null
  
)

export default component.exports